<div class="separador text-center">
  <h2 class="titulo ml-5">El trabajo
    cotidiano consiste en la recuperación de la dignidad de los niños, niñas y
    adolescentes a
    nuestro cuidado.</h2>
</div>
